import { createFileRoute } from '@tanstack/react-router';
import { requireFeature } from '@portal/platform/guards';
import { CustomersPage } from '@/features/customers-service-agreements/customers-page';

/** The cars to sell extension agreements for, in the type's sidebar section. Requires `vehicle:read`. */
export const Route = createFileRoute('/_app/service-agreement/customers/prolonging')({
  staticData: { featureKey: 'customers-service-agreements' },
  beforeLoad: ({ context, location }) =>
    requireFeature(context, location, {
      feature: 'customers-service-agreements',
      permissions: ['vehicle:read'],
    }),
  component: () => <CustomersPage lockedType="PROLONGING" />,
});
